import * as React from "react";
import {
  WindowWithChatbot,
  ClientChatbotStore,
  ConversationProperties,
  ConversationIntent,
  IntentTypes,
} from "src/stores/chatbotStore/ClientChatbotStore";
import { BlossomCustomerNotification } from "__generated__/api";
import { sendAnalytics } from "src/components/shared/CustomerNotifications/NotificationsWithDialog/NotificationQueryUtils";
import { UitkHeading } from "uitk-react-text";
import { UitkImage, UitkFigure, UitkFigureAspectRatioType } from "uitk-react-images";
import { UitkLayoutFlex, UitkLayoutFlexItem, UitkLayoutFlexItemProps } from "uitk-react-layout-flex";
import { UitkCardAloha, UitkCardAlohaLink } from "uitk-react-cards";
import Links = BlossomCustomerNotification.Links;
import Actions = BlossomCustomerNotification.Actions;
import { observer, inject } from "mobx-react";

interface ReasonsToBelieveCardProps {
  chatbot?: ClientChatbotStore;
  link?: Links;
  analyticsCallback?: (rfrr: string, linkName: string | null) => void;
  index: number;
  minWidth: UitkLayoutFlexItemProps["minWidth"];
  maxWidth: UitkLayoutFlexItemProps["maxWidth"];
}

export const ReasonsToBelieveCard: React.FC<ReasonsToBelieveCardProps> = inject("chatbot")(
  observer((props: ReasonsToBelieveCardProps) => {
    const { link, analyticsCallback, chatbot, index, maxWidth, minWidth } = props;
    const refundId = "openChatbot";
    const cancelTripId = "cancelChangeTrip";
    const useChatbot = link?.id === refundId || link?.id === cancelTripId;
    const images = [
      "https://forever.travel-assets.com/flex/flexmanager/images/2020/07/09/calendar_busy.svg",
      "https://forever.travel-assets.com/flex/flexmanager/images/2020/07/09/voucher.svg",
      "https://forever.travel-assets.com/flex/flexmanager/images/2020/07/09/approved.svg",
    ];

    const refundIntent: ConversationIntent = {
      intent: IntentTypes.REFUND_STATUS,
    };
    const cancelIntent = {
      intent: IntentTypes.VIEW_BOOKING,
    };

    const conversationProperties: ConversationProperties = {
      launchPoint: "ReasonsToBelieve",
      pageName: "StoreFront",
    };

    /* istanbul ignore next */
    const onChatbotClick = async (e: React.MouseEvent<HTMLElement>) => {
      e.preventDefault();
      if (analyticsCallback) {
        sendAnalytics(link?.actions as Actions[], analyticsCallback);
      }
      if (chatbot && useChatbot) {
        const windowChatObject = chatbot.getWebChatObject(window as WindowWithChatbot);
        const initialized = await windowChatObject?.isInitialized;
        if (initialized) {
          const intentMessage = refundId === link?.id ? refundIntent : cancelIntent;
          chatbot.startConversation(conversationProperties, intentMessage);

          return;
        }
      }
      window.location.href = link?.url;
    };

    return (
      <UitkLayoutFlexItem grow={1} maxWidth={maxWidth} minWidth={minWidth}>
        <UitkCardAloha padded={true}>
          <UitkLayoutFlex alignItems="center" space="six">
            <UitkLayoutFlexItem minWidth={48} shrink={0}>
              <div>
                <UitkFigure ratio={UitkFigureAspectRatioType.R1_1}>
                  <UitkImage src={images[index]} />
                </UitkFigure>
              </div>
            </UitkLayoutFlexItem>
            <UitkLayoutFlexItem grow={1}>
              <UitkHeading level={2} size={500}>
                {link?.text}
              </UitkHeading>
            </UitkLayoutFlexItem>
          </UitkLayoutFlex>
          <UitkCardAlohaLink>
            <a onClick={onChatbotClick} href="#">
              {link?.text}
            </a>
          </UitkCardAlohaLink>
        </UitkCardAloha>
      </UitkLayoutFlexItem>
    );
  })
);
